import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export default function RefundPolicy() {
  return (
    <div className="min-h-screen bg-pastel-gradient">
      <div className="container-pastel px-4 py-12">
        <Link
          to="/"
          className="inline-flex items-center text-gray-600 hover:text-gray-900 mb-8 font-poppins"
        >
          <ArrowLeft className="w-4 h-4 mr-2" />
          Back to Home
        </Link>

        <div className="card-pastel p-8">
          <h1 className="text-3xl font-bold text-gray-800 mb-8 font-poppins">Refund Policy</h1>

          <div className="max-w-none text-gray-700">
            <p className="text-sm text-gray-500 mb-6 font-poppins">Last updated: {new Date().toLocaleDateString()}</p>

            <div className="bg-white/60 p-6 rounded-lg mb-8">
              <h2 className="text-xl font-semibold mb-4 text-gray-800 font-poppins">Table of Contents</h2>
              <ol className="list-decimal list-inside space-y-2 font-poppins text-gray-600">
                <li><a href="#digital-services" className="hover:text-pastel-purple-600">Digital Services</a></li>
                <li><a href="#gift-contributions" className="hover:text-pastel-purple-600">Gift Contributions</a></li>
                <li><a href="#refund-process" className="hover:text-pastel-purple-600">Refund Process</a></li>
                <li><a href="#processing-time" className="hover:text-pastel-purple-600">Processing Time</a></li>
                <li><a href="#contact-us" className="hover:text-pastel-purple-600">Contact Us</a></li>
              </ol>
            </div>

            <section id="digital-services" className="mb-8">
              <h2 className="text-2xl font-bold mb-4 text-gray-800 font-poppins">1. Digital Services</h2>
              <p className="mb-4 font-poppins">As Giftyfy primarily provides digital registry services, we have a limited refund policy:</p>
              <ul className="list-disc list-inside space-y-2 ml-4 font-poppins text-gray-600">
                <li>Registry creation services are non-refundable once activated</li>
                <li>Premium features are non-refundable after usage begins</li>
                <li>Subscription services may be cancelled but are non-refundable for the current billing period</li>
              </ul>
            </section>

            <section id="gift-contributions" className="mb-8">
              <h2 className="text-2xl font-bold mb-4 text-gray-800 font-poppins">2. Gift Contributions</h2>
              <p className="mb-4 font-poppins">For gift contributions and group gifting:</p>
              <ul className="list-disc list-inside space-y-2 ml-4 font-poppins text-gray-600">
                <li>Contributions may be refunded within 24 hours of making the contribution</li>
                <li>After 24 hours, refunds are subject to review and approval</li>
                <li>Refunds will be processed to the original payment method</li>
                <li><strong>Refunds will be given to the payment-initiated media itself</strong></li>
              </ul>
            </section>

            <section id="refund-process" className="mb-8">
              <h2 className="text-2xl font-bold mb-4 text-gray-800 font-poppins">3. Refund Process</h2>
              <p className="mb-4 font-poppins">To request a refund:</p>
              <ul className="list-disc list-inside space-y-2 ml-4 font-poppins text-gray-600">
                <li>Contact our support team within the eligible timeframe</li>
                <li>Provide your order/contribution reference number</li>
                <li>Explain the reason for your refund request</li>
              </ul>
            </section>

            <section id="processing-time" className="mb-8">
              <h2 className="text-2xl font-bold mb-4 text-gray-800 font-poppins">4. Processing Time</h2>
              <p className="mb-4 font-poppins">Once approved:</p>
              <ul className="list-disc list-inside space-y-2 ml-4 font-poppins text-gray-600">
                <li>Credit card refunds: 5-10 business days</li>
                <li>Bank transfers: 7-14 business days</li>
                <li>Other payment methods: Processing time varies</li>
              </ul>
            </section>

            <section id="contact-us" className="mb-8">
              <h2 className="text-2xl font-bold mb-4 text-gray-800 font-poppins">5. Contact Us</h2>
              <p className="mb-2 font-poppins">For refund requests or questions, please contact us at:</p>
              <p className="mb-1 font-poppins"><strong>Email:</strong> support@giftyfy.com</p>
              <p className="font-poppins"><strong>Phone:</strong> +94 779257975</p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
}
